module.exports = __webpack_public_path__ + "static/media/pie-chart.2cfacdf6.png";